import CategoryModel from "../sdk/CategoryModel"
import config from "config"
import shop from "./shop"

export default class SessionModelMags {
  constructor(data) {
    Object.assign( this, data )
    if ( this.value.extras.min_order_value ) {
      config.MIN_ORDER_VALUE = this.value.extras.min_order_value
    }
  }
}



// WEBPACK FOOTER //
// ./src/shop/SessionModelMags.js